module.exports = __webpack_public_path__ + "static/media/5.7af3a52c.jpg";